//  React TS Helper Functions
import pxToRem from '../functions/pxToRem'

// types
type Types = any

/**
 * A single flat hairline.
 *
 * It used to be a fading white gradient, which read as a decorative rule. The
 * skin has no outlines, so a divider is only ever structural: one neutral line
 * in the divider token, at full opacity, where the layout genuinely needs a
 * break.
 */
const divider: Types = {
  styleOverrides: {
    root: {
      backgroundColor: 'var(--dewi_colors_gray_8)',
      backgroundImage: 'none',
      height: pxToRem(1),
      margin: `${pxToRem(16)} 0`,
      borderBottom: 'none',
      border: 'none',
      opacity: 1,
    },

    vertical: {
      backgroundColor: 'var(--dewi_colors_gray_8)',
      backgroundImage: 'none',
      width: pxToRem(1),
      height: '100%',
      margin: `0 ${pxToRem(16)}`,
      borderRight: 'none',
    },

    light: {
      backgroundColor: 'var(--dewi_colors_gray_7)',
      backgroundImage: 'none',

      '&.MuiDivider-vertical': {
        backgroundImage: 'none',
      },
    },
  },
}

export default divider
